function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "ae5ecf1e-71e2-4e6f-b4df-ae9e7b262d41",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.52,38.56A19,19,0,0,0,30.06.72h-.12a19,19,0,0,0-2.46,37.84l.81.11v8.64h-7a1.65,1.65,0,0,0,0,3.29h7v7A1.65,1.65,0,0,0,30,59.28h.1a1.64,1.64,0,0,0,1.65-1.64v-7h7a1.65,1.65,0,0,0,0-3.29h-7V38.67Zm-8.15-4.18a33.75,33.75,0,0,1-4.78-2.81,15.78,15.78,0,0,1-5-8.59l-.08-.36c-.06-.36-.21-1.62-.23-1.88l0-.45v-.06c0-.2,0-.41,0-.61a15.8,15.8,0,0,1,31.57-1c0,.18,0,1.18,0,1.18,0,.46-.08,1.49-.08,1.49a15.55,15.55,0,0,1-5.13,10.14v0l-.62.5a15.49,15.49,0,0,1-4.21,2.45l-1.09.4a16.21,16.21,0,0,1-3.45.68c-.3,0-.6,0-.91,0H30l-1.21-.05a16,16,0,0,1-3.35-.65Z"
}));

var SvgPersonalFemale = function SvgPersonalFemale(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPersonalFemale, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/personal_female.943a7595.svg";
export { ForwardRef as ReactComponent };